import { useCallback, useMemo } from 'react';
import { rage } from '~/rage';
import { ModalButtonColor, ModalType, WalletType } from '~/shared';
import { useLayoutSelector } from '../redux';

const useBuy = () => {
	const activeList = useLayoutSelector(
		(state) => state.vehicleService.activeList,
	);
	const activeListIndex = useLayoutSelector(
		(state) => state.vehicleService.activeListIndex,
	);

	const item = useMemo(
		() => activeList[activeListIndex || 0],
		[activeList, activeListIndex],
	);

	const handleBuy = useCallback(
		(walletType: WalletType) => {
			const text = `Вы действительно хотите оплатить ${
				walletType === WalletType.Cash ? 'наличными' : 'картой'
			} товар "${item.name}"`;

			rage.modal.showModal(
				{
					type: ModalType.Price,
					title: 'Подтверждение',
					text: text,
					price: item.price,
					wallet: walletType,
					acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
					cancelButton: {
						text: 'Отменить',
						color: ModalButtonColor.Secondary,
					},
				},
				(result) => {
					if (result.isAccepted) {
						rage.vehicleServiceStation.buyConsumable(item.id);
					}
				},
			);
		},
		[item],
	);

	return { handleBuy };
};

export { useBuy };
